module.exports = __webpack_public_path__ + "img/ilustraciones_nosotros.690a30aa.svg";